const translations = {
  IT: {
    nav: {
      home: "Home", showcase: "Showcase", projects: "Progetti", services: "Servizi",
      about: "Chi Siamo", contact: "Contatti", bookConsultation: "Prenota Consulenza",
    },
    hero: {
      line1: "FALEGNAMERIA ARTIGIANALE",
      line2: "PER LA TUA CASA",
      subtitle: "Porte interne, rifiniture, rivestimenti in legno e falegnameria edile su misura nella zona di Bari e dintorni.",
      bookCta: "Prenota Consulenza",
    },
    elegance: {
      title: "DOVE IL LEGNO PRENDE FORMA",
      text: "Realizziamo e installiamo elementi in legno per la casa e l'immobile: porte interne con telai e controtelai, coprifili, battiscopa, boiserie, pannellature e rivestimenti a parete. Ogni lavorazione è eseguita con precisione artigianale, materiali selezionati e cura maniacale per i dettagli — dalla posa alla rifinitura finale.",
    },
    featured: {
      title: "I NOSTRI SERVIZI",
      subtitle: "Installazioni, rifiniture e lavorazioni in legno per la tua casa, il cantiere e l'immobile.",
      viewShowcase: "Vedi Showcase",
      items: [],
    },
    project: {
      title: "HAI UN PROGETTO IN MENTE?", subtitle: "Realizziamo qualcosa di duraturo insieme.",
      steps: ["Sopralluogo", "Selezione Materiali", "Lavorazione & Posa"],
    },
    footer: {
      contact: "Contatti", services: "Servizi", followUs: "Seguici",
      rights: "© 2026 GDM - Wood Installations. Tutti i diritti riservati.",
      services_list: ["Porte Interne & Telai", "Rifiniture in Legno", "Falegnameria Edile"],
    },
    showcase: { title: "SHOWCASE", subtitle: "Una selezione delle nostre lavorazioni" },
    projects: {
      title: "I NOSTRI LAVORI", subtitle: "Ogni lavoro racconta una storia di artigianato e precisione",
      readMore: "Scopri di più", backToProjects: "← Torna ai Lavori", materials: "Materiali Utilizzati",
      requestSimilar: "Richiedi Lavoro Simile", otherProjects: "ALTRI LAVORI",
    },
    services: {
      title: "I NOSTRI SERVIZI", subtitle: "Lavorazioni artigianali in legno per l'edilizia — Zona Bari e dintorni",
      items: [
        {
          title: "Porte Interne, Telai & Controtelai",
          description: "Installazione professionale di porte interne con telaio, controtelaio e tutti gli elementi di finitura: coprifili, cornici e accessori.",
          details: [
            "Porte battenti, scorrevoli e a libro",
            "Montaggio telai e controtelai",
            "Posa coprifili e cornici",
            "Porte filo muro e binari a incasso",
          ],
          cta: "Richiedi Preventivo",
        },
        {
          title: "Rifiniture & Rivestimenti in Legno",
          description: "Posa e installazione di tutti gli elementi di rifinitura in legno per pareti e ambienti: battiscopa, boiserie, pannellature e rivestimenti a parete.",
          details: [
            "Battiscopa su misura",
            "Boiserie e pannellature a parete",
            "Rivestimenti in legno",
            "Cornici e profili decorativi fissi",
          ],
          cta: "Richiedi Preventivo",
        },
        {
          title: "Falegnameria Edile & Su Misura",
          description: "Realizzazione e installazione di elementi in legno per l'edilizia e l'immobile: scale, ringhiere, travi, pensiline, strutture e lavorazioni su misura per componenti fissi.",
          details: [
            "Scale in legno e ringhiere",
            "Travi, pensiline e strutture in legno",
            "Elementi decorativi fissi su misura",
            "Adattamenti e riparazioni di elementi lignei installati",
          ],
          cta: "Contattaci",
        },
      ],
    },
    about: {
      title: "CHI SIAMO", subtitle: "Una storia di passione e artigianato",
      story: "Dal 2026, GDM - Wood Installations nasce dalla passione per il legno e dall'esperienza diretta nella falegnameria per l'edilizia. Operiamo nella zona di Bari e dintorni, specializzandoci nell'installazione di elementi lignei per la casa e l'immobile: dalle porte interne alle rifiniture, dai rivestimenti alle strutture in legno. Ogni lavorazione porta con sé cura maniacale per i dettagli e un amore profondo per il legno.",
      values_title: "I Nostri Valori",
      values: [
        { title: "Qualità", text: "Solo materiali selezionati, scelti per durabilità e resa estetica." },
        { title: "Tradizione", text: "Tecniche artigianali applicate con esperienza e rispetto del legno." },
        { title: "Precisione", text: "Ogni posa, ogni rifinitura, ogni dettaglio eseguiti al millimetro." },
        { title: "Affidabilità", text: "Tempi rispettati, preventivi chiari, lavoro garantito." },
      ],
      process_title: "IL NOSTRO PROCESSO",
    },
    contact: {
      title: "CONTATTACI", subtitle: "Siamo qui per aiutarti. Compila il modulo e ti risponderemo il prima possibile.",
      name: "Nome", surname: "Cognome", email: "Email", phone: "Telefono", message: "Messaggio",
      namePlaceholder: "Il tuo nome", surnamePlaceholder: "Il tuo cognome",
      emailPlaceholder: "La tua email", phonePlaceholder: "Il tuo numero",
      messagePlaceholder: "Descrivi il tuo progetto (porte, rivestimenti, scale, strutture in legno...)",
      cancel: "Annulla", confirm: "Invia",
      projectTitle: "HAI UN PROGETTO IN MENTE?", projectSubtitle: "Realizziamo qualcosa di duraturo insieme.",
      requestConsultation: "Richiedi Consulenza",
      successMsg: "Messaggio inviato con successo! Ti contatteremo presto.",
      errorMsg: "Errore nell'invio. Riprova più tardi.",
    },
  },
  EN: {
    nav: {
      home: "Home", showcase: "Showcase", projects: "Projects", services: "Services",
      about: "About", contact: "Contact", bookConsultation: "Book Consultation",
    },
    hero: {
      line1: "ARTISAN WOODWORK",
      line2: "FOR YOUR HOME",
      subtitle: "Interior doors, wood finishes, wall cladding and bespoke building carpentry in the Bari area and surroundings.",
      exploreCta: "Explore Our Work", bookCta: "Book Consultation",
    },
    elegance: {
      title: "WHERE WOOD TAKES SHAPE",
      text: "We craft and install wood elements for the home and property: interior doors with frames and counter-frames, architraves, skirting boards, boiserie, wall panelling and cladding. Every piece is executed with artisanal precision, carefully selected materials and full attention to detail — from installation to final finish.",
    },
    featured: {
      title: "OUR SERVICES",
      subtitle: "Installations, finishes and custom woodwork for your home, building site and property.",
      viewShowcase: "View Showcase",
      items: [],
    },
    project: {
      title: "HAVE A PROJECT IN MIND?", subtitle: "Let's build something lasting together.",
      steps: ["Site Visit", "Material Selection", "Fabrication & Installation"],
    },
    footer: {
      contact: "Contact", services: "Services", followUs: "Follow Us",
      rights: "© 2026 GDM - Wood Installations. All rights reserved.",
      services_list: ["Interior Doors & Frames", "Wood Finishes", "Building Carpentry"],
    },
    showcase: { title: "SHOWCASE", subtitle: "A selection of our work" },
    projects: {
      title: "OUR WORK", subtitle: "Every project tells a story of craftsmanship and precision",
      readMore: "Read More", backToProjects: "← Back to Projects", materials: "Materials Used",
      requestSimilar: "Request Similar Work", otherProjects: "MORE WORK",
    },
    services: {
      title: "OUR SERVICES", subtitle: "Artisan woodwork for building and property — Bari area and surroundings",
      items: [
        {
          title: "Interior Doors, Frames & Counter-Frames",
          description: "Professional installation of interior doors complete with frames, counter-frames and all finishing elements: architraves, cornices and hardware.",
          details: [
            "Hinged, sliding and folding doors",
            "Frame and counter-frame fitting",
            "Architrave and cornice installation",
            "Flush-wall doors and concealed rails",
          ],
          cta: "Request a Quote",
        },
        {
          title: "Wood Finishes & Wall Cladding",
          description: "Supply and installation of all wood finishing elements for walls and interiors: skirting boards, boiserie, wall panelling and fixed decorative profiles.",
          details: [
            "Custom skirting boards",
            "Boiserie and wall panelling",
            "Wood wall cladding",
            "Fixed decorative profiles and cornices",
          ],
          cta: "Request a Quote",
        },
        {
          title: "Building Carpentry & Bespoke Elements",
          description: "Fabrication and installation of structural and decorative wood elements for the property: staircases, railings, beams, canopies, timber structures and custom-made fixed components.",
          details: [
            "Wooden staircases and railings",
            "Beams, canopies and timber structures",
            "Fixed bespoke decorative elements",
            "Repairs and adaptations of installed wood elements",
          ],
          cta: "Contact Us",
        },
      ],
    },
    about: {
      title: "ABOUT US", subtitle: "A story of passion and craftsmanship",
      story: "Since 2026, GDM - Wood Installations was born from a passion for wood and direct experience in building carpentry. We operate in the Bari area and surroundings, specialising in the installation of wood elements for the home and property: from interior doors to finishes, from wall cladding to timber structures. Every job reflects meticulous attention to detail and a deep love for wood.",
      values_title: "Our Values",
      values: [
        { title: "Quality", text: "Only selected materials, chosen for durability and finish." },
        { title: "Tradition", text: "Artisanal techniques applied with experience and respect for the wood." },
        { title: "Precision", text: "Every fit, every finish, every detail executed to the millimetre." },
        { title: "Reliability", text: "Deadlines met, clear quotes, guaranteed workmanship." },
      ],
      process_title: "OUR PROCESS",
    },
    contact: {
      title: "GET IN TOUCH", subtitle: "We're here to help. Fill out the form below and we'll get back to you as soon as possible.",
      name: "First Name", surname: "Last Name", email: "Email", phone: "Phone", message: "Message",
      namePlaceholder: "Your first name", surnamePlaceholder: "Your last name",
      emailPlaceholder: "Your email address", phonePlaceholder: "Your phone number",
      messagePlaceholder: "Describe your project (doors, cladding, staircases, timber structures...)",
      cancel: "Cancel", confirm: "Send",
      projectTitle: "HAVE A PROJECT IN MIND?", projectSubtitle: "Let's build something lasting together.",
      requestConsultation: "Request Consultation",
      successMsg: "Message sent successfully! We'll contact you soon.",
      errorMsg: "Error sending message. Please try again later.",
    },
  },
};

export default translations;
